import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { CTAButton } from "./CTAButton";
import { LANDINGS } from "../lib/landings";

// Pick up to N related landings, excluding the current slug.
const pickRelated = (excludeSlug, n) => {
    const others = LANDINGS.filter((l) => l.slug !== excludeSlug);
    if (n >= others.length) return others;
    // Deterministic pseudo-shuffle based on exclude slug so each page gets a
    // consistent (but varying) set.
    const seed = excludeSlug
        .split("")
        .reduce((acc, c) => acc + c.charCodeAt(0), 0);
    const rotated = [...others.slice(seed % others.length), ...others.slice(0, seed % others.length)];
    return rotated.slice(0, n);
};

export const RelatedReports = ({ exclude = "", limit = 3 }) => {
    const items = pickRelated(exclude, limit);
    return (
        <section
            data-testid="related-reports"
            className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 md:py-28 border-t border-[color:var(--brr-border)]"
        >
            <div className="flex items-end justify-between flex-wrap gap-6 mb-10">
                <div>
                    <span className="brr-overline">Continue Reading</span>
                    <h2 className="font-serif-display text-3xl sm:text-4xl mt-4">
                        More from the{" "}
                        <span className="italic">Better Rest Report</span>
                    </h2>
                </div>
                <CTAButton
                    label="Check Today's Offer"
                    testId="related-cta-check-offer"
                />
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                {items.map((it) => {
                    const slugId = it.slug
                        .replace(/[^a-z0-9]+/gi, "-")
                        .replace(/^-|-$/g, "");
                    return (
                        <Link
                            key={it.slug}
                            to={it.slug}
                            data-testid={`related-card-${slugId}`}
                            className="group bg-white border border-[color:var(--brr-border)] rounded-2xl p-7 md:p-8 flex flex-col justify-between transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_24px_60px_-30px_rgba(28,40,51,0.25)]"
                        >
                            <div>
                                <span className="brr-overline">
                                    {it.kicker}
                                </span>
                                <h3 className="font-serif-display text-xl sm:text-2xl mt-3 mb-3 leading-snug">
                                    {it.h1}
                                </h3>
                                <p className="text-[14px] leading-relaxed text-[color:var(--brr-ink-2)] font-light">
                                    {it.description}
                                </p>
                            </div>
                            <span className="mt-6 flex items-center gap-2 text-[11px] tracking-[0.2em] uppercase opacity-80 group-hover:opacity-100">
                                Read
                                <ArrowUpRight size={14} strokeWidth={1.5} />
                            </span>
                        </Link>
                    );
                })}
            </div>
            <div className="mt-12">
                <Link
                    to="/"
                    data-testid="related-link-home"
                    className="btn-ghost"
                >
                    Back to the Better Rest Report
                </Link>
            </div>
        </section>
    );
};
